var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._g({staticClass:"item--1 sidebar-section--3",attrs:{"to":_vm.to}},_vm.$listeners),[(_vm.leftIcon)?_c('left-icon',{attrs:{"name":_vm.leftIcon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }